import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminHeader, Badge } from "@/pages/admin/AdminLayout";
import { Button } from "@/components/ui/button";

const fmt = (iso) => { if (!iso) return "—"; const d = new Date(iso); return isNaN(d) ? "—" : `${d.toLocaleDateString(undefined, { month: "short", day: "numeric" })} · ${d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}`; };

export default function SupportTickets() {
    const qc = useQueryClient();
    const { data } = useQuery({ queryKey: ["admin-support-tickets"], queryFn: async () => (await api.get("/admin/support-tickets")).data });
    const close = async (id) => { await api.put(`/admin/support-tickets/${id}`); toast.success("Ticket closed"); qc.invalidateQueries({ queryKey: ["admin-support-tickets"] }); };
    const rows = data || [];
    const open = rows.filter((t) => t.status === "open");

    return (
        <div>
            <AdminHeader title="Support Tickets" subtitle="Questions the AI assistant escalated to your team — account, billing, safety, and verification issues." />
            <div className="space-y-3">
                {rows.length === 0 && <p className="text-sm text-zinc-500" data-testid="support-empty">No escalated tickets yet.</p>}
                {rows.map((t) => (
                    <div key={t.id} data-testid={`ticket-${t.id}`} className={`rounded-lg border p-5 ${t.status === "open" ? "border-red-200 bg-red-50/40" : "border-zinc-200 bg-white"}`}>
                        <div className="flex flex-wrap items-start justify-between gap-3">
                            <div className="max-w-2xl">
                                <div className="flex items-center gap-2">
                                    <Badge tone={t.status === "open" ? "red" : "gray"}>{t.status}</Badge>
                                    <span className="text-xs text-zinc-400">{fmt(t.created_at)}</span>
                                </div>
                                <p className="mt-2 text-sm"><span className="text-zinc-500">Member:</span> <span className="font-600">{t.member_name || "—"}</span> <span className="text-zinc-400">· {t.member_email}</span></p>
                                <p className="mt-1 rounded bg-white px-3 py-2 text-sm ring-1 ring-black/5">{t.question}</p>
                            </div>
                            {t.status === "open" && (
                                <Button size="sm" variant="outline" data-testid={`ticket-close-${t.id}`} onClick={() => close(t.id)}>Mark resolved</Button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            {open.length > 0 && <p className="mt-4 text-xs text-zinc-400">{open.length} open ticket{open.length === 1 ? "" : "s"}.</p>}
        </div>
    );
}
